module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper",
    class: [_vm.direction, {
      'dragging': _vm.dragging
    }],
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        _vm._onTouchStart($event)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        _vm._onTouchStart($event)
      },
      "wheel": _vm._onWheel
    }
  }, [_c('div', {
    ref: "swiper-wrap",
    staticClass: "swiper-wrap",
    style: ({
      'transform': 'translate3d(' + _vm.translateX + 'px,' + _vm.translateY + 'px, 0)',
      'transition-duration': _vm.transitionDuration + 'ms'
    }),
    on: {
      "transitionend": _vm._onTransitionEnd
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paginationVisible),
      expression: "paginationVisible"
    }],
    staticClass: "swiper-pagination"
  }, _vm._l((_vm.slideEls), function(slide, index) {
    return _c('span', {
      staticClass: "swiper-pagination-bullet",
      class: {
        'active': (index + 1) === _vm.currentPage
      },
      on: {
        "click": function($event) {
          _vm.paginationClickable && _vm.setPage(index + 1)
        }
      }
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-0ede842b","buble":{"objectAssign":"Object.assign"}}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-swiper.vue
// module id = 199
// module chunks = 2